import './Cart.scss';

import React from 'react';
import PropTypes from 'prop-types';

import Rails from '@rails/ujs';

import CartItem from './CartItem';
import ClearCart from '../ui/elements/buttons/Delete';
import CreateOrderForm from './CreateOrderForm';
import Currency from '../ui/elements/Currency';
import Icon from '../ui/elements/Icon';
import Loader from '../ui/elements/Loader';
import PageTitle from '../ui/layout/PageTitle';
import Turbolinks from 'turbolinks';

const SORT_BY_ALPHABET = 'SORT_BY_ALPHABET';
const SORT_BY_CREATED_AT = 'SORT_BY_CREATED_AT';

class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cartItems: this.props.cartItems || [],
      discardedCartItems: this.props.discardedCartItems || [],
      isLoading: false,
      sorting: this.props.sorting,
      forWarranty: this.props.forWarranty,
      activatedPromocode: this.props.activatedPromocode,
      activeRebate: this.props.activeRebate,
      allSelected: this.props.allSelected
    };

    this.handleClear = this.handleClear.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeCartItem = this.handleChangeCartItem.bind(this);
    this.handleChangeOrderForm = this.handleChangeOrderForm.bind(this);
    this.handleChangeSelected = this.handleChangeSelected.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handlePromocode = this.handlePromocode.bind(this);
    this.handleRebate = this.handleRebate.bind(this);
    this.handleChangeAllSelected = this.handleChangeAllSelected.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    fetch('/cart_items.json', { credentials: 'same-origin' })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then((response) => {
        const user = window._current_user.id;
        const promocode = response['cart_items'].filter((cartItem) => cartItem.code)[0];
        this.setState({
          cartItems: response['cart_items'].map((cartItem) => ({ ...cartItem, selected: user === cartItem.user.id })),
          discardedCartItems: response['discarded_cart_items'].map((cartItem) => ({ ...cartItem, selected: null })),
          forWarranty: (response['cart_items'][0] && response['cart_items'][0].isWarranty),
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        alert('Возникла ошибка при попытке загрузить информацию о деталях в корзине');
      });
  }

  handleClear() {
    if (this.props.needConfirm && (!this.props.needConfirm || !confirm("Вы уверены, что хотите очистить корзину?"))) {
      return false;
    }

    this.setState({ isLoading: true });
    fetch('/cart_items/clear', {
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      method: 'DELETE',
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(() => {
        this.setState({ cartItems: [], isLoading: false });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        alert('При попытке очистить корзину возникла ошибка.');
      });
  }

  handleDelete(id) {
    this.setState((state) => ({
      cartItems: state.cartItems.filter((cartItem) => cartItem.id !== id),
      discardedCartItems: state.discardedCartItems.filter((cartItem) => cartItem.id !== id),
    }));
    this.componentDidMount();
  }

  handleChangeCartItem(id, data) {
    this.setState((state) => ({
      cartItems: state.cartItems.map((cartItem) => {
        if (cartItem.id === id) {
          return {
            ...cartItem,
            airDelivery: data.airDelivery,
            quantity: data.quantity,
            price: data.price,
            sum: data.sum,
          };
        } else {
          return cartItem;
        }
      }),
    }));
    this.componentDidMount()
  }

  handleChangeOrderForm() {
    this.componentDidMount()
  }

  handleChangeSelected(id, selected) {
    this.setState((state) => ({
      cartItems: state.cartItems.map((cartItem) => {
        if (cartItem.id === id) {
          return { ...cartItem, selected: selected };
        } else {
          return cartItem;
        }
      }),
    }));

    if (this.props.onChangeSelected) {
      this.props.onChangeSelected(id, selected);
    }
  }

  handleSortingChange(newSorting) {
    this.setState({ sorting: newSorting });

    const data = new FormData();
    data.append('user[cart_items_sort_type]', newSorting.toLowerCase());
    fetch(`/settings.json`, {
      body: data,
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      method: 'PATCH',
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .catch((error) => {
        alert('Произошла ошибка при попытке сохранить в настройках сортировку по-умолчанию');
      });
  }

  handlePromocode() {
    const data = new FormData();
    const code = document.getElementById('code-input').value;
    if (code) {
      data.append('code', code);
      fetch(`/cart_items/check_promocode.json`, {
        body: data,
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': Rails.csrfToken() },
        method: 'POST',
      })
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((response) => {
          if (response["notice"]) {
            alert(response["notice"]);
            document.getElementById('code-input').value = "";
          } else {
            this.componentDidMount();
          }

        })
        .catch((error) => {
          alert('Произошла ошибка при попытке использовать промокод');
        });
    }
  }

  handleRebate(clause) {
    const data = new FormData();
    if (clause) {
      this.setState({ isLoading: true });
      data.append('rebate_clause_id', clause.id);
      fetch(`/cart_items/rebate_clause_agree.json`, {
        body: data,
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': Rails.csrfToken() },
        method: 'POST',
      })
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((response) => {
          if (response["notice"]) {
            alert(response["notice"]);
          } else {
            this.state.activeRebate = clause;
            this.componentDidMount();
          }
          this.setState({ isLoading: false });
        })
        .catch((error) => {
          alert('Произошла ошибка');
        });
    }
  }

  handleChangeAllSelected(event) {
    this.setState({
      allSelected: event.target.checked,
      cartItems: this.state.cartItems.map((cartItem) => ({ ...cartItem, selected: event.target.checked })),
    });
  }

  get hasBrandsWithAirDelivery() {
    return this.state.cartItems.filter((cartItem) => cartItem.part.brand.airDelivery).length > 0;
  }

  get hasFragileParts() {
    return this.selectedCartItems.filter((cartItem) => cartItem.part.fragile).length > 0;
  }

  get hasCompensationParts() {
    return this.selectedCartItems.filter((cartItem) => cartItem.needCompensation).length > 0;
  }

  get hasUnavailableFordParts() {
    return this.selectedCartItems.filter((cartItem) => cartItem.part.fordAndUnavailable).length > 0;
  }

  get selectedCartItems() {
    return this.state.cartItems.filter((cartItem) => cartItem.selected);
  }

  pluralize(count, variants) {
    let variant;

    if ([5, 6, 7, 8, 9, 0].includes(count % 10) || (count >= 11 && count <= 14)) {
      variant = variants[2];
    } else if ([2, 3, 4].includes(count % 10)) {
      variant = variants[1];
    } else {
      variant = variants[0];
    }

    return count + ' ' + variant;
  }

  sortingFunction(sortingType) {
    switch (sortingType) {
      case SORT_BY_ALPHABET:
        return function (cartItem1, cartItem2) {
          const a = [cartItem1.part.brand.name, cartItem1.part.article, cartItem1.part.description].join('');
          const b = [cartItem2.part.brand.name, cartItem2.part.article, cartItem2.part.description].join('');
          if (a < b) {
            return -1;
          }
          if (a > b) {
            return 1;
          }
          return 0;
        };
      case SORT_BY_CREATED_AT:
        return function (cartItem1, cartItem2) {
          if (cartItem1.createdAt < cartItem2.createdAt) {
            return -1;
          }
          if (cartItem1.createdAt > cartItem2.createdAt) {
            return 1;
          }
          return 0;
        };
      default:
        throw new Error('Неизвестный способ сортировки деталей в корзине.');
    }
  }

  get sum() {
    return this.selectedCartItems.reduce((accumulator, cartItem) => {
      return accumulator + cartItem.sum;
    }, 0);
  }

  satisfiedWith(promotion) {
    if (promotion.minimalSum) {
      if (promotion.minimalQuantity) {
        return this.promotionSum(promotion) >= promotion.minimalSum && this.promotionQuantity(promotion) >= promotion.minimalQuantity;
      } else {
        return this.promotionSum(promotion) >= promotion.minimalSum;
      }

    } else if (promotion.minimalQuantity) {
      return this.promotionQuantity(promotion) >= promotion.minimalQuantity;
    } else {
      return this.promotionQuantity(promotion) > 0;
    }
  }

  rebateClausesNotOnlyForPrepayment() {
    return this.props.rebateClauses.filter(
      (rebateClause) => this.readableFor(rebateClause) &&
        (!this.state.activeRebate || rebateClause.cartDiscount != this.state.activeRebate.cartDiscount)
    );
  }

  activeRebateClausesNotOnlyForPrepayment() {
    return this.props.rebateClauses.filter(
      (rebateClause) => this.readableFor(rebateClause) &&
        (!this.state.activeRebate || rebateClause.cartDiscount != this.state.activeRebate.cartDiscount) &&
        (this.rebateSum(rebateClause) >= rebateClause.minimalSum)
    );
  }

  suitableFor(clause) {
    return clause && this.rebateSum(clause) > clause.minimalSum && clause.prepayment;
  }

  readableFor(clause) {
    return clause && this.rebateSum(clause) >= clause.messageSum && !clause.prepayment;
  }

  rebateSum(clause) {
    return this.selectedCartItems.reduce((accumulator, cartItem) => {
      if ((clause.brandIds.length == 0 || clause.brandIds.includes(cartItem.part.brandId)) && (cartItem.rebatable)) {
        return accumulator + cartItem.sum;
      } else {
        return accumulator;
      }
    }, 0);
  }

  partsForShipmentNotice(notice) {
    let items;
    if (notice.forCar) {
      items = this.selectedCartItems.filter((cartItem) => cartItem.part.notAvailableInMoscow && notice.brandIds.includes(cartItem.part.brandId) && !cartItem.airDelivery);
    } else if (notice.forAir) {
      items = this.selectedCartItems.filter((cartItem) => cartItem.part.notAvailableInMoscow && notice.brandIds.includes(cartItem.part.brandId) && cartItem.airDelivery);
    } else {
      items = this.selectedCartItems.filter((cartItem) => cartItem.part.notAvailableInMoscow && notice.brandIds.includes(cartItem.part.brandId));
    };
    return items.map((cartItem) => cartItem.part.shortName)
  }

  daysForShipmentNotice(notice) {
    return this.pluralize(notice.daysToShipment, ['день', 'дня', 'дней']);
  }

  prizeCount(promotion) {
    if (promotion.maximumPrizesAmount == 1) {
      return promotion.prizeNameFor1;
    } else if (promotion.minimalQuantity) {
      let count = 0;
      if (promotion.maximumPrizesAmount) {
        count = Math.min(promotion.maximumPrizesAmount, Math.floor(this.promotionQuantity(promotion) / promotion.minimalQuantity));
      } else {
        count = Math.floor(this.promotionQuantity(promotion) / promotion.minimalQuantity);
      }
      return this.pluralize(count, [promotion.prizeNameFor1, promotion.prizeNameFor2, promotion.prizeNameFor5]);
    } else if (promotion.minimalSum) {
      let count = 0;
      if (promotion.maximumPrizesAmount) {
        count = Math.min(promotion.maximumPrizesAmount, Math.floor(this.promotionSum(promotion) / promotion.minimalSum));
      } else {
        count = Math.floor(this.promotionSum(promotion) / promotion.minimalSum);
      }
      return this.pluralize(count, [promotion.prizeNameFor1, promotion.prizeNameFor2, promotion.prizeNameFor5]);
    } else {
      return promotion.prizeNameFor1;
    }
  }

  promotionQuantity(promotion) {
    return this.selectedCartItems.reduce((accumulator, cartItem) => {
      if (promotion.partIds.length > 0 && promotion.partIds.includes(cartItem.part.id)) {
        return accumulator + cartItem.quantity;
      }
      else if ((promotion.brandIds.length == 0 || promotion.brandIds.includes(cartItem.part.brandId)) && (promotion.groupIds.length == 0 || promotion.groupIds.includes(cartItem.part.groupId))) {
        return accumulator + cartItem.quantity;
      } else {
        return accumulator;
      }
    }, 0);
  }

  promotionSum(promotion) {
    return this.selectedCartItems.reduce((accumulator, cartItem) => {
      if (promotion.partIds.length > 0 && promotion.partIds.includes(cartItem.part.id)) {
        return accumulator + cartItem.sum;
      }
      else if ((promotion.brandIds.length == 0 || promotion.brandIds.includes(cartItem.part.brandId)) && (promotion.groupIds.length == 0 || promotion.groupIds.includes(cartItem.part.groupId))) {
        return accumulator + cartItem.sum;
      } else {
        return accumulator;
      }
    }, 0);
  }

  get weight() {
    return this.selectedCartItems.reduce((accumulator, cartItem) => {
      return accumulator + cartItem.quantity * cartItem.part.weight;
    }, 0);
  }

  render() {
    const users = this.state.cartItems.concat(this.state.discardedCartItems).reduce((accumulator, cartItem) => {
      Object.defineProperty(accumulator, cartItem.user.id === window._current_user.id ? '' : cartItem.user.name, {
        value: cartItem.user.id,
      });
      return accumulator;
    }, {});
    const discarded = this.state.discardedCartItems.filter((cartItem) => cartItem.user.id === users[name]);
    const userNames = Object.getOwnPropertyNames(users).sort();

    const cartItems = userNames.map((name) => {
      return (
        <React.Fragment key={users[name]}>
          {userNames.length > 1 && (
            <tr>
              <td colSpan={this.hasBrandsWithAirDelivery ? 13 : 12}>
                <h3 className="title is-size-6">{name === '' ? 'Моя корзина' : name}</h3>
              </td>
            </tr>
          )}
          {this.state.cartItems
            .filter((cartItem) => cartItem.user.id === users[name])
            .sort(this.sortingFunction(this.state.sorting))
            .map((cartItem, index) => (
              <CartItem
                key={cartItem.id}
                airDelivery={cartItem.airDelivery}
                index={index}
                id={cartItem.id}
                limitQuantity={cartItem.limitQuantity}
                maximumQuantity={cartItem.maximumQuantity}
                minimumQuantity={cartItem.minimumQuantity}
                color={cartItem.color}
                textColor={cartItem.textColor}
                packingQuantity={cartItem.part.packingQuantity}
                packingUnit={cartItem.part.packingUnit}
                part={cartItem.part}
                price={cartItem.price}
                clearPrice={cartItem.clearPrice}
                quantity={cartItem.quantity}
                selected={cartItem.selected}
                showAirDelivery={this.hasBrandsWithAirDelivery}
                soldInPacks={cartItem.soldInPacks}
                rebateClauseId={cartItem.rebateClauseId}
                source={cartItem.source}
                sum={cartItem.sum}
                supplied={cartItem.part.supplied}
                onDelete={this.handleDelete}
                onChange={this.handleChangeCartItem}
                onChangeSelected={this.handleChangeSelected}
                quantityWasChanged={cartItem.quantityWasChanged}
                discarded={false}
                employee={this.props.employee}
                warrantyEmployee={this.props.warrantyEmployee}
                needConfirm={this.props.needConfirm}
                needReserveNote={this.props.needReserveNote}
                reservedAnalog={cartItem.reservedAnalog}
              />
            ))}
          {discarded.length > 0 && (
            <tr>
              <td colSpan={this.hasBrandsWithAirDelivery ? 13 : 12}>
                <h3 className="title is-size-6">Обратите внимание, со времени Вашей последней работы с заказом изменилось состояние наличия некоторых позиций. Отредактируйте, пожалуйста, заказ.</h3>
              </td>
            </tr>
          )}
          {this.state.discardedCartItems
            .filter((cartItem) => cartItem.user.id === users[name])
            .sort(this.sortingFunction(this.state.sorting))
            .map((cartItem, index) => (
              <CartItem
                key={cartItem.id}
                airDelivery={cartItem.airDelivery}
                index={index}
                id={cartItem.id}
                limitQuantity={cartItem.limitQuantity}
                maximumQuantity={cartItem.maximumQuantity}
                minimumQuantity={cartItem.minimumQuantity}
                color={cartItem.color}
                textColor={cartItem.textColor}
                packingQuantity={cartItem.part.packingQuantity}
                packingUnit={cartItem.part.packingUnit}
                part={cartItem.part}
                price={cartItem.price}
                clearPrice={cartItem.clearPrice}
                quantity={cartItem.quantity}
                selected={cartItem.selected}
                showAirDelivery={this.hasBrandsWithAirDelivery}
                soldInPacks={cartItem.soldInPacks}
                source={cartItem.source}
                rebateClauseId={cartItem.rebateClauseId}
                sum={cartItem.sum}
                supplied={cartItem.part.supplied}
                onDelete={this.handleDelete}
                onChange={this.handleChangeCartItem}
                onChangeSelected={this.handleChangeSelected}
                quantityWasChanged={cartItem.quantityWasChanged}
                discarded={true}
              />
            ))}
        </React.Fragment>
      );
    });

    const weight = this.weight > 0 && (
      <React.Fragment>
        <p className="is-size-7">примерный вес заказа</p>
        <p className="is-size-5">≈{this.weight.toLocaleString()} кг</p>
      </React.Fragment>
    );

    const partsWithChangedQuantity = this.state.cartItems.filter((item) => item.quantityWasChanged);

    const table = (
      <React.Fragment>
        {partsWithChangedQuantity.length > 0 &&
          <div className="notification is-info">
            Количество деталей {partsWithChangedQuantity.map((item) => item.part.article).join(', ')} увеличено до целой
            упаковки. Измененные позиции выделены цветом.
          </div>}
        <div className="select Cart-selectSorting">
          <select value={this.state.sorting} onChange={(event) => this.handleSortingChange(event.target.value)}>
            <option value={SORT_BY_ALPHABET}>Сортировать по бренду, артикулу, наименованию</option>
            <option value={SORT_BY_CREATED_AT}>Сортировать по времени добавления</option>
          </select>
        </div>
        <table className="table Cart is-bordered cart-items-cart-with">
          <thead>
            <tr>
              <th className="has-text-centered is-vertically-middle" />
              <th className="has-text-centered is-vertically-middle">Бренд</th>
              <th className="has-text-centered is-vertically-middle">Артикул</th>
              <th className="has-text-centered is-vertically-middle">Наименование детали</th>
              <th className="has-text-centered is-vertically-middle">Цена</th>
              <th className="has-text-centered is-vertically-middle">Склад</th>
              <th className="has-text-centered is-vertically-middle">Наличие</th>
              <th className="has-text-centered is-vertically-middle">Статус</th>
              <th className="has-text-centered is-vertically-middle">Количество</th>
              {this.hasBrandsWithAirDelivery && (
                <th className="has-text-centered is-vertically-middle CartItem-th-with-icon" title="Укажите необходимость авиадоставки">
                  <Icon icon="plane-departure" size="medium" />
                </th>
              )}
              <th className="has-text-centered is-vertically-middle">Стоимость</th>
              <th className="has-text-centered is-vertically-middle" />
              <th className="has-text-centered is-vertically-middle">
                <input type="checkbox" checked={this.state.allSelected} onChange={this.handleChangeAllSelected} />
              </th>
            </tr>
          </thead>
          <tbody>{cartItems}</tbody>
          {this.selectedCartItems.length > 0 && (
            <tfoot className="Cart-total">
              <tr>
                <td style={{ borderRight: 0 }} colSpan="3" />
                <td style={{ borderRight: 0, borderLeft: 0 }} colSpan="3">{weight}</td>
                <td style={{ borderRight: 0, borderLeft: 0 }}
                  className="has-text-right is-nowrapped is-size-2 Cart-total"
                  colSpan={this.hasBrandsWithAirDelivery ? 5 : 4}
                >
                  <Currency value={this.sum} />
                </td>
                <td style={{ borderRight: 0, borderLeft: 0 }}>
                  <ClearCart title="Очистить корзину" onDelete={this.handleClear} />
                </td>
                <td style={{ borderLeft: 0 }} />
              </tr>
            </tfoot>
          )}
        </table>
        {this.props.promocodes.length > 0 && (
          <div className="field promo">
            <div className="field has-addons">
              <div className="control">
                <input id="code-input" defaultValue={this.state.activatedPromocode} placeholder="Промокод" className="input"></input>
              </div>

              <div className="control">
                <button disabled={this.state.activatedPromocode} className="button is-info" onClick={(event) => this.handlePromocode()}>
                  <span className="icon">
                    <i className="fas fa-check"></i>
                  </span>
                  <span>применить</span>
                </button>
              </div>
            </div>
            {this.state.activatedPromocode && (
              <p className="help is-success">Промокод успешно применён</p>
            )}
            <br></br>
          </div>
        )}
        {this.selectedCartItems.length > 0 && (
          <CreateOrderForm
            addresses={this.props.addresses}
            branches={this.props.branches}
            companies={this.props.companies}
            dealers={this.props.dealers}
            deliveryPreferences={this.props.deliveryPreferences}
            cartItems={this.selectedCartItems}
            deliveryWays={this.props.deliveryWays}
            paymentTypes={this.props.paymentTypes}
            fragile={this.hasFragileParts}
            dealerFord={this.props.dealerFord}
            warrantyEmployee={this.props.warrantyEmployee}
            forWarranty={this.state.forWarranty}
            selectedBranch={this.props.selectedBranch}
            selectedDeliveryWay={this.props.selectedDeliveryWay}
            employee={this.props.employee}
            canBuyForClient={this.props.canBuyForClient}
            canPayOnline={this.props.canPayOnline}
            canSendToBranch={this.props.canSendToBranch}
            hasUnavailableFordParts={this.hasUnavailableFordParts}
            onSubmit={this.handleSubmit}
            onChange={this.handleChangeOrderForm}
            orderSum={this.sum}
            needCompensation={this.hasCompensationParts}
            needInfo={this.props.needInfo}
            recommended={false}
          />
        )}
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <React.Fragment>
          <PageTitle title="Корзина" />
          {this.state.isLoading && cartItems.length === 0 && <Loader text="Загрузка информации о товарах..." />}
          {this.state.isLoading && cartItems.length > 0 && <div className="Cart-loading">{table}</div>}
          {!this.state.isLoading && cartItems.length === 0 && <p>Ваша корзина пуста.</p>}
          {/* {
            this.sumNrf > 0 && (<div className="notification is-info">
              <p className="has-text-weight-bold">
                В рамках акции <a href="https://turbotrucks.ru/articles/64">«Акция NRF: Ваш эксперт в системе охлаждения»</a> Вы получаете
              {' ' + this.pluralize(this.sumNrf, ['фирменную футболку', 'фирменные футболки', 'фирменных футболок'])} в подарок.
              </p>
            </div>)
          } */}
          {
            this.props.notices.length > 0 && (
              this.props.notices.map((notice, i) => (this.partsForShipmentNotice(notice).length > 0 && (<div style={{ marginBottom: "0.5rem" }} key={i} className="notification is-warning">
                <p className="has-text-weight-bold">
                  Уведомляем Вас, что {this.partsForShipmentNotice(notice).length > 1 ? 'детали' : 'деталь'} {this.partsForShipmentNotice(notice).join(', ')} {this.partsForShipmentNotice(notice).length > 1 ? 'будут поставлены' : 'будет поставлена'} через {this.daysForShipmentNotice(notice)}. Способ доставки в РФ «{notice.deliveryWay}».
                </p>
              </div>)))
            )
          }
          {
            this.props.promotions.length > 0 && (
              this.props.promotions.map((promotion, i) => (this.satisfiedWith(promotion) && (<div style={{ marginBottom: "0.5rem" }} key={i} className="notification is-info">
                <p className="has-text-weight-bold">
                  В рамках акции <a href={"https://turbotrucks.ru/articles/" + promotion.articleId}>«{promotion.articleName}»</a> Вы получаете
                  {' ' + this.prizeCount(promotion)} в подарок.
                </p>
              </div>)))
            )
          }
          {this.props.rebateClauses.length > 0 &&
            this.activeRebateClausesNotOnlyForPrepayment().length === 0 &&
              (this.props.rebateClauses.filter((rebateClause) => this.suitableFor(rebateClause)).map(
                (rebateClause, i) => (!this.state.activeRebate && (
                  <div style={{ marginBottom: "0.5rem" }} key={i} className="notification has-background-success-bleached-super">
                    <p>
                      При внесении предоплаты за оригинальные запасные части {rebateClause.brandNames} Ваша скидка увеличится
                      до {rebateClause.cartDiscount}%
                    </p>
                    <p className="is-size-7">Предложение не распространяется на детали под заказ.</p>
                    <br></br>
                    <div className="control">
                      <button className="button" onClick={(event) => this.handleRebate(rebateClause)}>
                        Получить скидку {rebateClause.cartDiscount}%
                      </button>
                    </div>
                  </div>
                ))
            )
          )}
          {this.props.rebateClauses.length > 0 && (this.rebateClausesNotOnlyForPrepayment().map((rebateClause, i) => (
            (
              <div style={{marginBottom: "0.5rem"}} key={i} className="notification">
                <p>
                  При размещении заказа на оригинальные запасные части {rebateClause.brandNames} от <Currency
                  value={Math.ceil(rebateClause.minimalSum)}/> и внесение предварительной оплаты Ваша скидка увеличится
                  до {rebateClause.cartDiscount}%
                </p>
                <p className="is-size-7">Предложение не распространяется на детали под заказ.</p>
                <br/>
                <div className="control">
                  <button
                    className="button"
                    disabled={this.rebateSum(rebateClause) < rebateClause.minimalSum}
                    title={this.rebateSum(rebateClause) < rebateClause.minimalSum ? `Сумма заказа менее ${~~rebateClause.minimalSum} рублей` : ''}
                    onClick={(event) => this.handleRebate(rebateClause)}
                  >
                      Получить скидку {rebateClause.cartDiscount}%
                  </button>
                </div>
              </div>
            )))
          )}
          {this.state.activeRebate && this.suitableFor(this.state.activeRebate) && (
            <div>
              <p className="is-size-5 has-text-danger-dark">Обратите внимание! Для получения заказа требуется
                предварительная оплата за оригинальные запасные части {this.state.activeRebate.brandNames}.</p>
              <p className="is-size-7 has-text-danger-dark">Предложение не распространяется на детали под заказ.</p>
              <br/>
              {this.props.discountButton &&
                <div>
                  <form action="/cart_items/uncheck_rebate" method="post">
                    <button type="submit" className="button is-warning is-small"><Icon icon="tag"  /> <span>Сбросить скидку по предоплате</span></button>
                  </form>
                  <br/><br/>
                </div>
              }
            </div>
          )}

        </React.Fragment>
        {!this.state.isLoading && cartItems.length > 0 && table}
      </React.Fragment>
    );
  }
}

Cart.propTypes = {
  branches: PropTypes.arrayOf(PropTypes.object),
  companies: PropTypes.arrayOf(PropTypes.object),
  promocodes: PropTypes.arrayOf(PropTypes.object),
  rebateClauses: PropTypes.arrayOf(PropTypes.object),
  cartItems: PropTypes.arrayOf(PropTypes.object),
  promotions: PropTypes.arrayOf(PropTypes.object),
  notices: PropTypes.arrayOf(PropTypes.object),
  discardedCartItems: PropTypes.arrayOf(PropTypes.object),
  deliveryWays: PropTypes.arrayOf(PropTypes.object),
  paymentTypes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  deliveryPreferences: PropTypes.arrayOf(PropTypes.object),
  selectedBranch: PropTypes.number,
  selectedDeliveryWay: PropTypes.number,
  sorting: PropTypes.string,
  employee: PropTypes.bool,
  promotion: PropTypes.bool,
  canBuyForClient: PropTypes.bool,
  needConfirm: PropTypes.bool,
  discountButton: PropTypes.bool,
  needReserveNote: PropTypes.bool,
  needCompensation: PropTypes.bool,
  needInfo: PropTypes.bool,
  canPayOnline: PropTypes.bool,
  warrantyEmployee: PropTypes.bool,
  onChangeSelected: PropTypes.func,
  allSelected: PropTypes.bool
};

export default Cart;
